import { defineComponent as _defineComponent } from 'vue'
import { Link, router } from '@inertiajs/vue2';
import IconEmail from '@/components/icons/IconEmail.vue';
import IconEyeHide from '@/components/icons/IconEyeHide.vue';
import IconEyeOpen from '@/components/icons/IconEyeOpen.vue';
import IconLock from '@/components/icons/IconLock.vue';
import { usePasswordVisibility } from '../composables/passwords';
import type { LoginFormData, Incomplete } from '../types';
import { reactive } from 'vue';
import route from 'ziggy-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const passwordVisibility = usePasswordVisibility();

const formData = reactive<Incomplete<LoginFormData>>({
    password: null,
    email: null,
    remember: null,
});

function handleSubmit(data: LoginFormData) {
    router.post(route('login'), data);
}

return { __sfc: true,passwordVisibility, formData, handleSubmit, Link, IconEmail, IconEyeHide, IconEyeOpen, IconLock, route }
}

})